"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(articles, comments, files, ratings, subscriptions, tags, settings) {
        this.articles = articles;
        this.comments = comments;
        this.files = files;
        this.ratings = ratings;
        this.subscriptions = subscriptions;
        this.tags = tags;
        this.settings = settings;
    }
    var _a, _b, _c, _d, _e, _f, _g;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleCommentsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ArticleFilesClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.ArticleRatingsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.ArticleSubscriptionsClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.ArticleTagsClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.ArticleSettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleClient !== "undefined" && _1.ArticleClient) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleCommentsClient !== "undefined" && _1.ArticleCommentsClient) === "function" ? _b : Object, typeof (_c = typeof _1.ArticleFilesClient !== "undefined" && _1.ArticleFilesClient) === "function" ? _c : Object, typeof (_d = typeof _1.ArticleRatingsClient !== "undefined" && _1.ArticleRatingsClient) === "function" ? _d : Object, typeof (_e = typeof _1.ArticleSubscriptionsClient !== "undefined" && _1.ArticleSubscriptionsClient) === "function" ? _e : Object, typeof (_f = typeof _1.ArticleTagsClient !== "undefined" && _1.ArticleTagsClient) === "function" ? _f : Object, typeof (_g = typeof _1.ArticleSettingsClient !== "undefined" && _1.ArticleSettingsClient) === "function" ? _g : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
